import React, { useState } from 'react'
import { apiGet, apiPost } from '../../../generic/Api_Functions'
import SmartMateriaUITable from '../../../generic/SmartMateriaUITable'
import AlertUI from '../../../generic/AlertUI'
import { IconButton, Typography } from '@mui/material'
import { SmartDialog } from '../../../generic/utilities/SmartDialog'

import { useSmartTranslation } from '../../../generic/hooks/useSmartTranslation'

import { PanTool, StopCircleOutlined } from '@mui/icons-material'
import RequestControlledStopDialog from './RequestControlledStopDialog'
import createDialogTitle from '../../../generic/utilities/dialogUtil'

const WorkingParts = (props) => {
  const [AlertElement, showAlert] = AlertUI()
  const [selectedRow, setSelectedRow] = useState({})
  const [showStopDialog, setShowStopDialog] = useState(false)
  const [showCancelSheduledStopDialog, setShowCancelSheduledStopDialog] = useState(false)

  const { t_ } = useSmartTranslation()

  const getTableData = async (pagination) => {
    const parts = await apiGet('workingParts/', pagination)
    if (selectedRow.id) {
      const selected = parts.content.find((p) => p.id === selectedRow.id)
      if (selected) {
        if (selected.status !== 'FINISHED') {
          setSelectedRow(selected)
        }
      } else {
        setSelectedRow({})
        setShowStopDialog(false)
      }
    }
    return parts
  }

  const columns = [
    {
      name: t_('Code'),
      field: 'code',
      readOnly: true
    },
    {
      name: t_('Name'),
      field: 'name',
      readOnly: true
    },
    {
      name: t_('Description'),
      field: 'description',
      charLimit: 200,
      readOnly: true
    },
    {
      name: t_('Raw Material Reference'),
      field: 'rawMaterialReference.code',
      readOnly: true
    },
    {
      name: t_('Fixture'),
      field: 'fixture.code',
      readOnly: true
    },
    {
      name: t_('Location'),
      field: 'location.name',
      readOnly: true
    },
    {
      name: t_('Shelf'),
      field: 'shelveStorageConfiguration.shelve',
      readOnly: true
    },
    {
      name: t_('Row'),
      field: 'shelveStoragePosition.position',
      readOnly: true
    },
    {
      name: t_('Column'),
      field: 'shelveStoragePosition.depth',
      readOnly: true
    },
    {
      name: t_('Client'),
      field: 'client.name',
      readOnly: true
    },
    {
      name: t_('Fabrication Order'),
      field: 'fabricationOrder.fabricationOrder',
      readOnly: true
    }
  ]

  const actions = {
    custom: [
      {
        name: t_('Stop after this part'),
        render: (row) => {
          return (
            <IconButton>
              <PanTool />
            </IconButton>
          )
        },
        onClick: (row) => {
          setSelectedRow(row)
          if (row.hasScheduledStop) {
            setShowCancelSheduledStopDialog(true)
            return
          }
          setShowStopDialog(true)
        },
        color: (row) => row.hasScheduledStop ? 'warning' : undefined
      }
    ]
  }

  return (
    <>
      {AlertElement}
      <SmartDialog
        setOpen={showCancelSheduledStopDialog}
        title={createDialogTitle({ title: t_('Cancel Stop?'), icon: StopCircleOutlined })}
        cancelCallback={() => setShowCancelSheduledStopDialog(false)}
        renderComponent={<Typography>{t_('Are you sure you want to cancel the scheduled stop for this part?')}</Typography>}
        acceptCallback={() => {
          apiPost('cancelRequestControlledStop/' + selectedRow.id).then(() => {
            setSelectedRow({})
            showAlert({
              title: t_('Success'),
              message: t_('Scheduled stop has been succesfully cancelled'),
              severity: 'success'
            })
          })
            .catch((error) => {
              showAlert({
                title: t_('Error cancelling scheduled stop'),
                message: t_(error.message),
                severity: error.name
              })
            })
          setShowCancelSheduledStopDialog(false)
        }}
      />
      <SmartMateriaUITable
        columns={columns}
        title={t_('Working Parts')}
        dataFetch={getTableData}
        actions={actions}
        multipleSelection={false}
        pageable
      />
      <SmartDialog
        renderComponent={<RequestControlledStopDialog part={selectedRow} closeDialog={() => setShowStopDialog(false)} showAlert={showAlert} />}
        setOpen={showStopDialog}
        cancel={false}
        accept={false}
        onClose={() => setShowStopDialog(false)}
      />

    </>
  )
}

export default WorkingParts
